<template>
  <div class="d-print-none">
    <b-container>

      <MainMenu/>

    </b-container>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import MainMenu from "./menus/MainMenu.vue";

export default {
  name: "Nav3",
  components: {MainMenu},
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      storeMenus: 'Menu/getStoreMenus'
    }),
  },
};
</script>

<style scoped>


</style>